<div class="toggle-btn" (click)="toggle()">
  <span class="btn-text">{{ isExpanded ? seeLessText : seeAllText }}</span>
  <span 
    class="arrow" 
    [ngStyle]="{'background-image': 'url(' + iconPath + ')'}"
    [class.rotate]="isExpanded">
  </span>
</div>
